/**
 * PATH: packages/email-hub/src/feature/cross-org-actions/openEmailInOrg.ts
 * FILE_ID: EMAILHUB-CROSSORG-OPEN-001
 * PURPOSE: Switch organisation context before opening a visible email copy.
 * WHY: Cross-org navigation must be explicit and must never reuse a source-org id.
 */
import { emailPath } from '../lib/basePath'

export type OpenEmailInOrgOutcome = 'opened' | 'switch-unavailable'

export interface OpenEmailInOrgInput {
  emailId: string
  targetOrgId: number
  currentOrgId: number | null
  switchOrganisation?: (orgId: number, orgName?: string) => Promise<void> | void
  targetOrgName?: string
  navigate: (to: string) => void
}

export function buildEmailCopyUrl(emailId: string): string {
  const search = new URLSearchParams({ open: emailId })
  return `${emailPath('/inbox')}?${search.toString()}`
}

export async function openEmailInOrg({
  emailId,
  targetOrgId,
  currentOrgId,
  switchOrganisation,
  targetOrgName,
  navigate,
}: OpenEmailInOrgInput): Promise<OpenEmailInOrgOutcome> {
  if (currentOrgId !== targetOrgId) {
    if (!switchOrganisation) return 'switch-unavailable'
    await switchOrganisation(targetOrgId, targetOrgName)
  }
  navigate(buildEmailCopyUrl(emailId))
  return 'opened'
}
